// ENTITY fr.gestionpial.pial.dto.NotificationListeDTO generated by ic2 no-version-available at Thu Oct 01 15:16:30 UTC 2026

import { mapping, fields } from '@ic2/ic2-lib';
import { TypeNotification } from './TypeNotification';

export class NotificationListeDTO {

  static readonly __ic2_fqn: string = 'fr.gestionpial.pial.dto.NotificationListeDTO';

  idNotification: number | null = 0;
  idClasse: number | null = 0;
  idPial: number | null = 0;
  nom: string | null = '';
  prenom: string | null = '';
  typeNotification: TypeNotification | null = null;
  volumeHoraireHebdo: number | null = 0;
  minutesPlanifiees: number | null = 0;
  dateDebut: Date | null = null;
  dateFin: Date | null = null;

  constructor(init?:Partial<NotificationListeDTO>) {
    Object.assign(this, init);
  }

  toString() {
    return JSON.stringify(this);
  }

}

mapping['fr.gestionpial.pial.dto.NotificationListeDTO'] = NotificationListeDTO;

fields['fr.gestionpial.pial.dto.NotificationListeDTO']  = {
    idNotification: 'java.lang.Integer',
    idClasse: 'java.lang.Integer',
    idPial: 'java.lang.Integer',
    nom: 'java.lang.String',
    prenom: 'java.lang.String',
    typeNotification: 'fr.gestionpial.pial.entities.TypeNotification',
    volumeHoraireHebdo: 'java.lang.Integer',
    minutesPlanifiees: 'java.lang.Integer',
    dateDebut: 'java.time.LocalDate',
    dateFin: 'java.time.LocalDate'
};
